export default __webpack_public_path__ + "static/media/to-deduction.93f4ecd1.svg";